document.addEventListener('click', function (e) {
    const cartToggle = document.querySelector('.cart-toggle')

    if (e.target.classList.contains('cart-toggle-btn')) {
        document.body.classList.toggle('mini-cart-open')
    }

    if (e.target !== cartToggle && !cartToggle.contains(e.target)) {
        document.body.classList.remove('mini-cart-open')
    }
})

// Unfournately WooCommerce uses jQuery so we need to use it here too
;(function ($) {
    let timeout

    $(document).on('click', '.add-to-cart-plusminus', function (e) {
        e.preventDefault()
        const miniCartItem = e.target.closest('.mini-cart-item')
        const qtyInput = miniCartItem.querySelector('input')
        const aPrice = miniCartItem.querySelector('.mini-cart-item-price > .the-price')
        let totPrice = miniCartItem.querySelector('.mini-cart-price > .the-price')

        let qty = parseInt(qtyInput.value),
            productQty,
            action,
            security

        if (e.target.matches('.cart-item-remove')) {
            action = 'remove_from_cart'
            security = tlGlobal.removeFromCart
            miniCartItem.style.opacity = '0.3'
            miniCartItem.style.pointerEvents = 'none'

            $('body').on('updated_checkout', function () {
                miniCartItem.style.display = 'none'
            })
        } else if (e.target.matches('.add-btn')) {
            productQty = qty + 1
            qtyInput.value = qty + 1

            if (qtyInput.value > 0) {
                totPrice.innerHTML = parseInt(aPrice.innerHTML) * productQty
            }

            action = 'deacrease_cart_item'
            security = tlGlobal.deacreaseCartItem
        } else if (e.target.matches('.sub-btn') && qty > 1) {
            productQty = qty - 1
            qtyInput.value = qty - 1

            if (qtyInput.value > 0) {
                totPrice.innerHTML = parseInt(aPrice.innerHTML) * productQty
            }

            action = 'deacrease_cart_item'
            security = tlGlobal.deacreaseCartItem
        } else {
            return
            // remove comment to enable removing item on minus click under 1
            // qytInput.value = qty - 1
            // action = 'remove_from_cart'
            // security = tlGlobal.removeFromCart
        }

        let handleCartBtn = $(this),
            productId = e.target.closest('.mini-cart-item').dataset.productId,
            variationId = e.target.closest('.mini-cart-item').dataset.variation || 0

        const ajaxData = {
            action: action,
            security: security,
            product_id: productId,
            product_sku: '',
            quantity: productQty,
            variation_id: variationId,
        }

        if (timeout !== undefined) {
            clearTimeout(timeout)
        }

        timeout = setTimeout(() => {
            $(document.body).trigger('adding_to_cart', [handleCartBtn, ajaxData])
            $.ajax({
                type: 'post',
                url: tlGlobal.adminUrl,
                data: ajaxData,

                beforeSend(response) {
                    document.body.classList.add('cart-loading')
                },
                success(response, statusTxt) {
                    if (tlGlobal.isCheckout) {
                        $(document.body).trigger('update_checkout')
                    } else {
                        $(document.body).trigger('added_to_cart', [
                            response.fragments,
                            response.cart_hash,
                            handleCartBtn,
                        ])
                    }

                    if (statusTxt === 'success') {
                        document.body.classList.remove('cart-loading')
                    }
                },
                error(error) {
                    console.log(error)
                },
            })
        }, 500)

        return false
    })
})(jQuery)
